<div class="dialog-header">
  <h2 mat-dialog-title>{{ isNewPatient ? 'Registrar paciente' : 'Editar paciente' }}</h2>
  <button mat-icon-button type="button" class="dialog-close" aria-label="Cerrar" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="patient-dialog">
  @if (invoicingEnabled()) {
    <mat-tab-group
      class="patient-tabs"
      animationDuration="0ms"
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      [selectedIndex]="tabIndex()"
      (selectedIndexChange)="tabIndex.set($event)"
    >
      <mat-tab label="Expediente">
        <div class="patient-tab">
          <ng-container *ngTemplateOutlet="expediente" />
        </div>
      </mat-tab>
      <mat-tab label="Cuenta">
        <div class="patient-tab">
          @if (patientId(); as id) {
            <app-patient-bills [patientId]="id" [patientName]="patientForm.controls.name.value" />
          } @else {
            <p class="patient-tab-note">Guarde el paciente para registrar cobros y pagos.</p>
          }
        </div>
      </mat-tab>
      @if (facturacionEnabled()) {
      <mat-tab label="Datos fiscales">
        <div class="patient-tab">
          <p class="patient-tab-note">
            Datos fiscales para facturar a este paciente. El uso de CFDI no viene en la constancia.
          </p>
          @if (patientId()) {
            <div class="patient-fiscal-actions">
              <input #constanciaInput class="patient-file" type="file" accept="application/pdf,.pdf" (change)="onConstancia($event)" />
              <button mat-stroked-button type="button" [disabled]="parsingCsf()" (click)="constanciaInput.click()">
                {{ parsingCsf() ? 'Leyendo constancia…' : 'Subir constancia' }}
              </button>
            </div>
            <form class="patient-grid" [formGroup]="fiscalForm">
              <app-outline-field class="span-2">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>RFC</mat-label>
                  <input
                    matInput
                    formControlName="rfc"
                    maxlength="13"
                    autocomplete="off"
                    (input)="normalizeFiscalRfc($event)"
                  />
                </mat-form-field>
              </app-outline-field>
              <app-outline-field class="span-2">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Nombre o razón social</mat-label>
                  <input matInput formControlName="name" autocomplete="off" />
                </mat-form-field>
              </app-outline-field>
              <app-outline-field class="span-2">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Régimen fiscal</mat-label>
                  <mat-select formControlName="fiscalRegime">
                    <mat-option value="">—</mat-option>
                    @for (option of fiscalRegimeOptions(); track option.code) {
                      <mat-option [value]="option.code">{{ option.code }} — {{ option.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </app-outline-field>
              <app-outline-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>C.P. fiscal</mat-label>
                  <input
                    matInput
                    formControlName="postalCode"
                    inputmode="numeric"
                    maxlength="5"
                    autocomplete="off"
                    (input)="normalizeFiscalPostal($event)"
                  />
                </mat-form-field>
              </app-outline-field>
              <app-outline-field class="span-2">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Uso de CFDI</mat-label>
                  <mat-select formControlName="cfdiUse">
                    <mat-option value="">—</mat-option>
                    @for (option of cfdiUseOptions; track option.code) {
                      <mat-option [value]="option.code">{{ option.code }} — {{ option.description }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </app-outline-field>
            </form>
            @if (fiscalRfc().trim()) {
              <section class="patient-invoices" aria-label="Facturas">
                <h3>Facturas</h3>
                @if (invoicesLoading()) {
                  <p class="patient-tab-note">Cargando facturas…</p>
                } @else if (invoicesError()) {
                  <p class="patient-invoice-error">{{ invoicesError() }}</p>
                } @else if (patientInvoices().length === 0) {
                  <p class="patient-tab-note">No hay facturas emitidas a este RFC.</p>
                } @else {
                  <ul class="patient-invoice-list">
                    @for (invoice of patientInvoices(); track invoice.id) {
                      <li class="patient-invoice" [class.patient-invoice--cancelled]="invoice.cancelled">
                        <div>
                          <p class="patient-invoice-folio">{{ invoiceFolio(invoice) }}</p>
                          <p class="patient-invoice-meta">
                            {{ invoiceWhen(invoice.emissionDate) }}
                            @if (invoiceType(invoice.cfdiType); as type) {
                              · {{ type }}
                            }
                            @if (invoice.cancelled) {
                              · Cancelada
                            }
                          </p>
                        </div>
                        <p class="patient-invoice-total">{{ invoiceMoney(invoice.total) }}</p>
                        <div class="patient-invoice-actions">
                          <button
                            mat-button
                            type="button"
                            [disabled]="!invoice.folio || invoiceBusy() != null"
                            (click)="downloadInvoice(invoice)"
                          >
                            {{ invoiceBusy() === invoice.id && invoiceAction() === 'pdf' ? 'Descargando…' : 'PDF' }}
                          </button>
                          <span
                            [matTooltip]="invoice.cancelled ? 'No se pueden mandar correos con facturas canceladas' : (!patientEmail() ? 'Agrega el correo del paciente' : '')"
                          >
                            <button
                              mat-button
                              type="button"
                              [disabled]="invoice.cancelled || !invoice.folio || !patientEmail() || invoiceBusy() != null"
                              (click)="emailInvoice(invoice)"
                            >
                              {{ invoiceBusy() === invoice.id && invoiceAction() === 'email' ? 'Enviando…' : 'Correo' }}
                            </button>
                          </span>
                        </div>
                      </li>
                    }
                  </ul>
                }
              </section>
            }
          } @else {
            <p class="patient-tab-note">Guarde el paciente para capturar sus datos fiscales.</p>
          }
        </div>
      </mat-tab>
      }
    </mat-tab-group>
  } @else {
    <ng-container *ngTemplateOutlet="expediente" />
  }
</mat-dialog-content>

<ng-template #expediente>
  <form class="patient-form" [formGroup]="patientForm" (change)="formChange()">
    <div class="patient-grid">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-2">
        <mat-label>Nombre</mat-label>
        <input matInput type="text" formControlName="name" autocomplete="name" />
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-2">
        <mat-label>Fecha de nacimiento</mat-label>
        <input
          matInput
          [matDatepicker]="dobPicker"
          formControlName="dob"
          [max]="dobMax"
          readonly
          (click)="dobPicker.open()"
          (dateChange)="formChange()"
        />
        <mat-datepicker-toggle matIconSuffix [for]="dobPicker"></mat-datepicker-toggle>
        <mat-datepicker #dobPicker startView="multi-year"></mat-datepicker>
      </mat-form-field>

      <ng-container formGroupName="fields">
        @for (field of fields; track field.key) {
          @switch (field.type) {
            @case ('select') {
              <mat-form-field appearance="outline" subscriptSizing="dynamic" [class.span-2]="field.width === 'medium'" [class.span-full]="field.width === 'full'">
                <mat-label>{{ field.label }}</mat-label>
                <mat-select [formControlName]="field.key" (selectionChange)="formChange()">
                  <mat-option value="">—</mat-option>
                  @for (option of selectOptions(field); track option) {
                    <mat-option [value]="option">{{ option }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @case ('textarea') {
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="notes-field" [class.span-2]="field.width === 'medium'" [class.span-full]="field.width === 'full'"
              >
                <mat-label>{{ field.label }}</mat-label>
                <textarea matInput rows="4" [formControlName]="field.key"></textarea>
              </mat-form-field>
            }
            @case ('spacer') {
              <div
                class="field-spacer"
                aria-hidden="true"
                [class.span-2]="field.width === 'medium'"
                [class.span-3]="field.width === 'wide'"
                [class.span-full]="field.width === 'full'"
              ></div>
            }
            @default {
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                [class.span-2]="field.width === 'medium'"
                [class.span-full]="field.width === 'full'"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  matInput
                  [type]="inputType(field)"
                  [formControlName]="field.key"
                  [attr.autocomplete]="autocomplete(field)"
                />
              </mat-form-field>
            }
          }
        }
      </ng-container>
    </div>
  </form>

  @if (patientId()) {
    <div class="patient-doc-actions">
      <button
        mat-stroked-button
        type="button"
        color="primary"
        appGuideAnchor="patient-generate-document"
        [disabled]="generatingDocument()"
        (click)="openGenerateDocument()"
      >
        {{ generatingDocument() ? 'Cargando…' : 'Generar documento' }}
      </button>
    </div>
  } @else {
    <div class="patient-doc-actions" aria-hidden="true"></div>
  }

  <app-supporting-documents
    [patientId]="patientId()"
    [uploadsEnabled]="uploadsEnabled()"
  />
</ng-template>
<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" type="button" [disabled]="saving()" (click)="saveAndClose()">
    {{ saving() ? 'Guardando…' : 'Guardar' }}
  </button>
</mat-dialog-actions>
